// extracted by css-extract-rspack-plugin
export default {"root":"root-vOVNxs","slotTargetChildren":"slotTargetChildren-MAIkrf","text__gSlk":"text__gSlk-rtYOri","textGSlk":"text__gSlk-rtYOri"};